import { getDefaultState } from './default'

const state = getDefaultState()

export { state }
